
import KowMap from '@/components/KowMap.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: { KowMap },
})
